import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const ROWS = [
  { key: "gold_24kt", label: "Oro 24 carati", purity: "999", badge: "ORO" },
  { key: "gold_22kt", label: "Oro 22 carati", purity: "916", badge: "ORO" },
  { key: "gold_21kt", label: "Oro 21 carati", purity: "875", badge: "ORO" },
  { key: "gold_18kt", label: "Oro 18 carati", purity: "750", badge: "ORO" },
  { key: "gold_14kt", label: "Oro 14 carati", purity: "585", badge: "ORO" },
  { key: "gold_9kt", label: "Oro 9 carati", purity: "375", badge: "ORO" },
  { key: "silver_925", label: "Argento 925", purity: "925", badge: "AG" },
];

export default function QuoteTable({ compact = false }) {
  const [q, setQ] = useState(null);
  useEffect(() => { api.get("/quotes").then((r) => setQ(r.data?.manual)); }, []);
  if (!q) return null;

  return (
    <div data-testid="quote-table" className="luxe-card overflow-hidden">
      <div className="grid grid-cols-12 px-6 py-4 border-b border-[var(--gold)]/20 bg-[#060f1f] text-[0.65rem] uppercase tracking-[0.25em] text-[var(--gold)]">
        <div className="col-span-6 md:col-span-5">Metallo</div>
        <div className="col-span-3 text-center hidden md:block">Purezza ‰</div>
        <div className="col-span-3 text-center">Caratura</div>
        <div className="col-span-3 md:col-span-1 text-right">€/g</div>
      </div>
      {ROWS.map((r) => (
        <div key={r.key} data-testid={`quote-${r.key}`} className="grid grid-cols-12 px-6 py-4 border-b border-white/5 items-center hover:bg-[var(--gold)]/[0.03] transition-colors">
          <div className="col-span-6 md:col-span-5 flex items-center gap-3">
            <span className={`w-9 h-9 flex items-center justify-center text-[0.6rem] font-bold tracking-widest rounded-sm ${r.badge === "ORO" ? "bg-[var(--gold)]/15 text-[var(--gold)] border border-[var(--gold)]/40" : "bg-white/5 text-white/70 border border-white/15"}`}>{r.badge}</span>
            <span className="font-serif text-lg text-white">{r.label}</span>
          </div>
          <div className="col-span-3 text-center text-white/60 font-mono text-sm hidden md:block">{r.purity}</div>
          <div className="col-span-3 text-center text-[var(--gold-soft)] text-sm">{r.key === "silver_925" ? "925" : r.label.match(/\d+/)?.[0] + "kt"}</div>
          <div className="col-span-3 md:col-span-1 text-right">
            <span className="font-serif gold-text text-2xl md:text-3xl">€ {Number(q[r.key] || 0).toFixed(2)}</span>
          </div>
        </div>
      ))}
      <div className="px-6 py-3 bg-[#060f1f]/60 text-[0.65rem] text-white/40 flex flex-wrap justify-between gap-2">
        <span>Aggiornato: {q.updated_at ? new Date(q.updated_at).toLocaleString("it-IT") : "—"}</span>
        <span>Fonte: BullionVault (fixing borsa metalli)</span>
      </div>
      <div className="px-6 py-4 bg-[var(--gold)]/[0.06] border-t border-[var(--gold)]/20 text-xs text-[var(--gold-soft)] text-center leading-relaxed">
        <strong className="text-[var(--gold)]">Attenzione:</strong> le quotazioni indicate sono <strong>prezzi di borsa</strong> del mercato internazionale dei metalli preziosi.
        Per scoprire il <strong>reale valore</strong> del tuo oro o argento, <a href="tel:+393389472101" className="underline">contattaci al 338 947 2101</a> o vieni in negozio per una valutazione gratuita.
      </div>
    </div>
  );
}
